/** React Query keys for the notifications feature (MYN-55). Flat/session-scoped, like `/invites`. */
export const notificationsKeys = {
  all: ['notifications'] as const,
};
